<template>
  <div v-if="!isLoading" class="guide">
    <div class="guide-header">
      <div class="item">
        <img src="../assets/logos/gfs.jpg" class="gfs-logo" />
      </div>
      <div class="item"><h1>GFS Stocking List</h1></div>
      <div class="item">
        <!-- <a href="./downloads/product guides/mpk-gfs-stocking-list.pdf" download
          ><h2>Download as PDF</h2></a
        > -->
      </div>
    </div>
    <div class="product-tables">
      <!-- <StockListTable
        :columns="goldkistColumns"
        :rows="goldkistItems"
        manufacturer="Gold Kist"
        logoUrl="goldkist.png"
        rowClass="goldkist"
      />
      <br /> -->
      <StockListTable
        :columns="columns"
        :rows="goldcreekItems"
        manufacturer="Gold Creek"
        logoUrl="goldcreekfoods.jpg"
        rowClass="goldcreek"
      />
      <br />
      <StockListTable
        :columns="columns"
        :rows="yangsItems"
        manufacturer="Yangs 5th Taste"
        logoUrl="yangs.png"
        rowClass="yangs"
      />
      <br />
      <StockListTable
        :columns="columns"
        :rows="bakecraftersItems"
        manufacturer="Bake Crafters"
        logoUrl="bakecrafters.jpg"
        rowClass="bakecrafters"
      />
      <br />
      <StockListTable
        :columns="columns"
        :rows="tastybrandsItems"
        manufacturer="Tasty Brands"
        logoUrl="tastybrands.png"
        rowClass="tastybrands"
      />
      <br />
      <StockListTable
        :columns="columns"
        :rows="wildmikesItems"
        manufacturer="Wild Mike's Pizza"
        logoUrl="wildmikes.jpg"
        rowClass="wildmikes"
      />
      <br />
      <StockListTable
        :columns="columns"
        :rows="jtmItems"
        manufacturer="JTM"
        logoUrl="jtm.png"
        rowClass="jtm"
      />
      <br />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import StockListTable from "../components/StockListTable.vue";

export default {
  name: "GFSStockList",
  data() {
    return {
      gfsData: [{}],
      isLoading: true,
      // goldkistItems: [{}],
      goldcreekItems: [{}],
      yangsItems: [{}],
      tastybrandsItems: [{}],
      bakecraftersItems: [{}],
      wildmikesItems: [{}],
      jtmItems: [{}],
      columns: [
        "Product Image",
        "Description",
        "Mfg Code",
        "Pack Size",
        "MMA",
        "Grain",
        "Stock Code",
      ]
      // goldkistColumns: [
      //   "Product Image",
      //   "Description",
      //   "Mfg Code",
      //   "Pack Size",
      //   "MMA",
      //   "Grain",
      //   "Chicken Type",
      //   "Stock Code",
      // ],
    };
  },
  mounted() {
    this.getGFSStockListData();
    //this.generateMfgLists();
  },
  methods: {
    getGFSStockListData() {
      this.isLoading = true;
      axios
        .get(process.env.VUE_APP_URL + "products/GetGFSStockList")
        .then((response) => {
          this.gfsData = response.data; //JSON.parse(response.data)
          this.generateMfgLists();
          this.isLoading = false;
        });
    },
    generateMfgLists() {
      // this.goldkistItems = this.processGoldKistItems(
      //   this.gfsData.filter((item) => item.Mfg == "Gold Kist")
      // );
      this.yangsItems = this.processItems(
        this.gfsData.filter((item) => item.Mfg == "Yangs 5th Taste")
      );
      this.tastybrandsItems = this.processItems(
        this.gfsData.filter((item) => item.Mfg == "Tasty Brands")
      );
      this.bakecraftersItems = this.processItems(
        this.gfsData.filter((item) => item.Mfg == "Bake Crafters")
      );
      this.wildmikesItems = this.processItems(
        this.gfsData.filter((item) => item.Mfg == "Wild Mike's")
      );
      this.goldcreekItems = this.processItems(
        this.gfsData.filter((item) => item.Mfg == "Gold Creek")
      );
      this.jtmItems = this.processItems(
        this.gfsData.filter((item) => item.Mfg == "JTM")
      );
    },
    processItems(items) {
      var processedItems = items.map((item) => {
        return {
          imageHTML: item.ImageHTML,
          pdfHTML: item.PdfHTML,
          mfgCode: item.MfgCode,
          packSize: item.PackSize,
          mma: item.MMA,
          grain: item.Grain,
          gfsStockCode: item.StockCode,
        };
      });

      return processedItems;
    },
    // processGoldKistItems(items) {
    //   var processedItems = items.map((item) => {
    //     return {
    //       imageHTML: item.ImageHTML,
    //       pdfHTML: item.PdfHTML,
    //       mfgCode: item.MfgCode,
    //       packSize: item.PackSize,
    //       mma: item.MMA,
    //       grain: item.Grain,
    //       chickenType: item.ChickenType,
    //       gfsStockCode: item.StockCode,
    //     };
    //   });

    //   return processedItems;
    // },
  },
  components: {
    StockListTable,
  },
};
</script>

<style scoped>
.guide-header {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.item {
  flex: 1 1 auto;
  font-weight: bold;
}
.gfs-logo {
  width: 150px;
}
.thumbnail {
  border: 1px solid #333;
  border-radius: 4px;
  max-width: 150px;
  margin: 5px 0 0;
}
.product-tables {
  max-width: 100vw;
  overflow-x: auto;
}
</style>
